var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissingControls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2677 4.08109C0.2677 3.30338 0.78092 2.61896 1.52749 2.40107L9.5143 0.0700887C9.83465 -0.023408 10.1751 -0.0233619 10.4954 0.070221L18.473 2.40084C19.2193 2.61888 19.7323 3.30318 19.7323 4.08072V8.59623C19.7319 11.5827 18.792 14.4934 17.0456 16.9161C15.413 19.1808 13.1531 20.9117 10.5509 21.8992C10.197 22.0335 9.8062 22.0336 9.45228 21.8994C6.84905 20.9122 4.58814 19.181 2.95495 16.9157C1.2079 14.4925 0.267744 11.5809 0.2677 8.59353V4.08109Z",
    fill: "#C86408"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96723 7.19366C8.96723 6.62343 9.42949 6.16116 9.99973 6.16116C10.57 6.16116 11.0322 6.62343 11.0322 7.19366V11.6146C11.0322 12.1848 10.57 12.6471 9.99973 12.6471C9.42949 12.6471 8.96723 12.1848 8.96723 11.6146V7.19366Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0464 14.8135C11.0464 15.3914 10.5779 15.8599 9.99996 15.8599C9.42203 15.8599 8.95353 15.3914 8.95353 14.8135C8.95353 14.2356 9.42203 13.7671 9.99996 13.7671C10.5779 13.7671 11.0464 14.2356 11.0464 14.8135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingControls);
export default __webpack_public_path__ + "static/media/missing_controls.e3b4a00908f651f63dc1d1b5af2c0913.svg";
export { ForwardRef as ReactComponent };